import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";

import { WebhookFormTableComponent } from "../webhook-form-table/webhook-form-table.component";

@Component({
    selector: 'webhook-form-simpletable',
    templateUrl: './webhook-form-simpletable.component.html',
    styleUrl:'./webhook-form-simpletable.component.scss',
    standalone: false,
})

export class WebhookFormSimpleTableComponent extends WebhookFormTableComponent implements OnInit {
 
    
    addRow() {
        
        if (this.newRow.valid) {
            this.rows.push(this.fb.group(this.newRow.value));
            this.mainformGroup.setControl(this.fieldNew, this.fb.array([...this.rows.controls]));
            this.cd.detectChanges();

            const total = this.rows.length;
            const pages = Math.ceil(total / this.pageSize);
            this.pageIndex = pages;


            this.newRow.reset();
        }else{
            Object.values(this.newRow.controls).forEach((control:FormControl) => {
                if (control.invalid) {
                    control.markAsDirty();
                    control.updateValueAndValidity({ onlySelf: true });
                }
          });
        }
    }
    
}
